<!--
 * @Descripttion: 人员选择器
 * @version: 
 * @Author: Ray
 * @Date: 2023-04-23 11:15:46
 * @LastEditors: Ray
 * @LastEditTime: 2024-11-04 13:17:31
-->
<template>
	<div>
		<el-dialog top="6vh" :model-value="modelValue" @close="closeSelector" width="600px" class="dialog-supplier" :destroy-on-close="isDestroy">
			<template #title>
				<div class="title flex">
					<div>{{ type === 1 ? "个人项目客户" : "企业项目客户" }}</div>
				</div>
			</template>
			<div class="supplier_content">
				<div class="supplier_content-header">
					<el-form :model="state.searchForm">
						<el-row :gutter="10">
							<el-col :span="type === 2 ? 10 : 14">
								<el-form-item label="" prop="personName" label-width="0px" v-if="type === 1">
									<el-input v-model="state.searchForm.personName" placeholder="请输入搜索内容" @input="onInput" clearable />
								</el-form-item>
								<el-form-item label="" prop="orgName" label-width="0px" v-else>
									<el-input v-model="state.searchForm.orgName" placeholder="请输入搜索内容" @input="onInput" clearable />
								</el-form-item>
							</el-col>
							<el-col :span="type === 2 ? 7 : 10">
								<el-form-item label="" prop="provinceList" label-width="0px">
									<el-cascader
										ref="cascaderArr"
										v-model="state.searchForm.provinceList"
										placeholder="请选择所在地省/市/区"
										:options="state.areaList"
										:props="state.areaProps"
										filterable
										clearable
										style="width: 100%"
										@change="provinceChange"
									/>
								</el-form-item>
							</el-col>
							<el-col :span="7" v-if="type === 2">
								<el-form-item label="" prop="orgType" label-width="0px">
									<el-select
										v-model="state.searchForm.orgType"
										filterable
										placeholder="请选择"
										style="width: 100%"
										clearable
										@change="classHandleChange"
									>
										<el-option v-for="item in state.orgTypeArr" :key="item.id" :label="item.name" :value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<div class="supplier_content-box" v-if="type === 1" v-infinite-scroll="load" v-loading="state.loading">
					<div class="card-box" v-for="(item, index) in state.cardList" :key="index">
						<div class="card-radio">
							<el-checkbox v-if="multiple" :model-value="item.checked" :label="item.id" @change="checkOnChange($event, item)">
								{{ "" }}
							</el-checkbox>
							<el-radio v-else :label="true" :model-value="item.checked" @change="checkOnChange($event, item)">
								{{ "" }}
							</el-radio>
						</div>
						<div class="portrait">
							{{ item.personName.slice(-2) }}
						</div>
						<div class="box-content">
							<p class="name">
								{{ item.personName }}
								<span>{{ item.sex === "1" ? "男" : "女" }}</span>
								<span>{{ doctorLevel(item.personType) }}</span>
							</p>
							<p class="detail">
								<span>{{ item.departmentName }}</span>
								<el-divider direction="vertical" />
								<span>{{ item.orgName }}</span>
							</p>
						</div>
					</div>
					<p class="bottom" v-if="state.noMore">暂无数据</p>
				</div>
				<div class="supplier_content-box" v-else v-infinite-scroll="load" v-loading="state.loading">
					<div class="card-box" v-for="(item, index) in state.cardList" :key="index">
						<div class="card-radio">
							<el-checkbox v-if="multiple" :model-value="item.checked" :label="item.id" @change="checkOnChange($event, item)">
								{{ "" }}
							</el-checkbox>
							<el-radio v-else :label="true" :model-value="item.checked" @change="checkOnChange($event, item)">
								{{ "" }}
							</el-radio>
						</div>
						<div class="portrait">
							{{ item.orgName.slice(-2) }}
						</div>
						<div class="box-content">
							<p class="name">{{ item.orgName }}</p>
							<p class="detail">
								<span>{{ doctorLevel(item.orgType) }}</span>
								<el-divider direction="vertical" />
								<span>{{ item.provinceName }}</span>
							</p>
						</div>
					</div>
					<p class="bottom" v-if="state.noMore">暂无数据</p>
				</div>
			</div>
			<div class="dialog-footer flex justify-end items-center">
				<el-button @click="closeSelector">取消</el-button>
				<el-button type="primary" @click="submitHandleClick" :disabled="state.selectList.length === 0">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script setup lang="ts">
import { ref, reactive, toRefs, watch, computed, onMounted } from "vue";
import { getAreaList, getPersonageClient, geOrganizationList } from "../../../service/crm"
defineOptions({
  name: "TqProjectCustomerSelector",
});
type Props = {
	modelValue: boolean,
	multiple?: boolean,
	selectedList?: Array<any>,
	type?: number,
	isDestroy?: boolean
}
const props = withDefaults(defineProps<Props>(), {
	modelValue: false,
	multiple: false,
	title: '',
	selectedList: () => {
		return []
	},
	// 1-个人 2-企业
	type: 1,
	isDestroy: false
})
const emit = defineEmits(["cancel", "confirm"]);

const { modelValue, multiple, selectedList, type, isDestroy } = toRefs(props)

const state = reactive({
	searchForm: {
		pageNo: 1,
		pageSize: 30,
		totalPages: 0,
		cityCode: "",
		provinceCode: "",
		regionCode: "",
		orgType: "",
		orgName: "",
		personName: "",
		auditState: 1, 
		mergeStatus: 0
	} as any, // 查询条件
	areaProps: {
		value: "areaCode",
		label: "areaName",
		children: "list",
	},
	loading: false, // 加载状态
	noMore: false, // 暂无数据
	cardList: [] as Array<any>, // 供应商数据
	areaList: [] as Array<any>, // 城市数据
	orgTypeArr: [
		{ id: "10", name: "医疗机构" },
		{ id: "20", name: "非医疗机构" },
		{ id: "30", name: "经销商" },
		{ id: "40", name: "药店" },
		{ id: "50", name: "部队采购站" },
		{ id: "60", name: "政府机构" },
		{ id: "70", name: "其他" },
	],
	selectList: [] as Array<any>, // 多选选中
	timer: null as any,
});
const cascaderArr = ref();

watch(selectedList.value,(newValue:Array<any>)=>{
	state.selectList = newValue
},{
	deep: true,
	immediate: true,
})
watch(modelValue.value,(val:any)=>{
	if(val && isDestroy.value){
		state.searchForm = {
			pageNo: 1,
			pageSize: 30,
			totalPages: 0,
			cityCode: "",
			provinceCode: "",
			regionCode: "",
			orgType: "",
			orgName: "",
			personName: "",
			auditState: 1, 
			mergeStatus: 0
		}
		searchData()
	}
},{
	deep: true,
	immediate: true,
})
onMounted(async()=>{
	await getAreaListData()
	if(!isDestroy.value){
		state.searchForm.pageNo = 1
		await searchData()
	}
})
/**
 * @description: 医生等级转换
 * @param[in] val
 * @return
 * @author: Ray
 */
const doctorLevel = (val:string)=> {
	let name = ""
	if (val) {
		state.orgTypeArr.forEach(item => {
			if (val == item.id) {
				name = item.name
			}
		})
	}
	return name
}
/**
 * @description: 分页
 * @return
 * @author: Ray
 */
const load = () => {
	state.searchForm.pageNo++
	if (state.searchForm.pageNo > state.searchForm.totalPages) {
		state.noMore = true
		return
	} else {
		state.noMore = false
	}
	props.type === 1 ? getPersonageClientData() : geOrganizationListData()
}
/**
 * @description: 查询数据
 * @return
 * @author: Ray
 */
const searchData = () => {
	state.cardList = []
	props.type === 1 ? getPersonageClientData() : geOrganizationListData()
}

/**
 * @description: 多选选中
 * @param[in] e
 * @return
 * @author: Ray
 */
const checkOnChange = (e:any, row:any) => {
	// 多选
	if (multiple.value) {
		row.checked = e
		if (e) {
			state.selectList.push(row)
		} else {
			state.selectList.map((item:any, index:number) => {
				if (item.code === row.code) {
					state.selectList.splice(index, 1)
				}
			})
		}
	} else {
		state.selectList = []
		state.cardList.map((item:any) => {
			if (row.id === item.id) {
				item.checked = true
				state.selectList.push(item)
			} else {
				item.checked = false
			}
		})
		console.log(e,row)
	}
}

/**
 * @description: 监听个人/企业项目客户模糊查询
 * @param[in] function
 * @return 
 * @author: Ray
 */		
const onInput = () =>{
	debounce(()=>{
		state.searchForm = {
			...state.searchForm,
			pageNo: 1,
		}
		searchData()
	},500)
}

/**
 * @description: 选择城市
 * @param[in] e
 * @return
 * @author: Ray
 */
const provinceChange = (e:any) => {
	console.log(e,'eeee')
	const checkedNode = cascaderArr.value.getCheckedNodes()
	console.log(checkedNode,'checkedNode')
	state.searchForm = {
		...state.searchForm,
		cityCode: !e || e.length === 0 ? "" : checkedNode[0].pathValues[1],
		cityName: !e || e.length === 0 ? "" : checkedNode[0].pathLabels[1],
		provinceCode: !e || e.length === 0 ? "" : checkedNode[0].pathValues[0],
		provinceName: !e || e.length === 0 ? "" : checkedNode[0].pathLabels[0],
		pageNo: 1,
	}
	searchData()
}

/**
 * @description: 选择集团外部供应商
 * @return
 * @author: Ray
 */
const classHandleChange = (e:string) => {
	state.searchForm = {
		...state.searchForm,
		supplierClassify: e,
		pageNo: 1,
	}
	searchData()
}

/**
 * @description: 提交
 * @return
 * @author: Ray
 */
const submitHandleClick = () => {
	emit("confirm", state.selectList)
}

/**
 * @description: 获取省市区数据
 * @return
 * @author: Ray
 */
const getPersonageClientData = async() => {
	state.loading = true
	const res = await getPersonageClient(state.searchForm)
	if (res.msgCode === "100") {
		const responseData = res.responseData.list
		state.searchForm.totalPages = res.responseData.totalPages
		if (responseData.length !== 0) {
			responseData.map((item:any) => {
				state.cardList.push(item)
			})
			state.cardList.map((item:any)=>{
				item.checked = state.selectList.filter((childItem:any) => childItem.id === item.id).length === 0 ? false : true
			})
			state.noMore = false
		} else {
			state.noMore = true
		}
	} else {
		state.noMore = true
	}
	state.loading = false
}
/**
 * @description: 获取企业供应商数据
 * @return
 * @author: Ray
 */
const geOrganizationListData = async() => {
	state.loading = true
	const res = await geOrganizationList(state.searchForm)
	if (res.msgCode === "100") {
		const responseData = res.responseData.list
		state.searchForm.totalPages = res.responseData.totalPages
		if (responseData.length !== 0) {
			responseData.map((item:any) => {
				item.checked = state.selectList.filter((childItem:any) => childItem.id === item.id).length === 0 ? false : true
				state.cardList.push(item)
			})
			state.noMore = false
		} else {
			state.noMore = true
		}
	}
	state.loading = false
	state.noMore = false
}

/**
 * @description: 获取省市区数据
 * @return
 * @author: Ray
 */
const getAreaListData = async() => {
	const res = await getAreaList()
	if (res.msgCode === "100") {
		let data = res.responseData
		data.map((item:any) => {
			item.list.map((childItem:any) => {
				delete childItem.list
			})
		})
		state.areaList = data
	}
}

// 自定义防抖函数
function debounce(fn:any, delay:any) {
	//闭包
	// 如果定时器已经存在了，则需要清除
	if (state.timer) {
		clearTimeout(state.timer);
	}
	// 重新执行当前的函数
	state.timer = setTimeout(() => fn(), delay);
}

/**
 * @description: 关闭弹窗
 * @return
 * @author: Ray
 */
const closeSelector = () => {
	// @ts-ignore
	emit("update:modelValue", false)
}
</script>
